import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'antd/dist/reset.css'; // Ant Design global styles
import './index.css';
import '@rainbow-me/rainbowkit/styles.css';


const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <App />
  );
